import React from 'react'
interface ReportHeaderProps{
    label: string;
}
const ReportHeader:React.FC<ReportHeaderProps> = ({label}) => {
    return (
        <div className='flex flex-col'>
            <h1 className='text-md font-bold text-sky-950 dark:text-slate-200 text-opacity-75'>{label}</h1>
            <p className='text-start text-[10px] text-red-700 dark:text-red-600'>All the fields marked with an (*) are mandatory.</p>
        </div>
    )
}

export default ReportHeader